import React from 'react';
import classNames from 'classnames';

export type FooterProps = {
  justify?: 'start' | 'center' | 'end';
  className?: string;
  children?: React.ReactNode;
};

export const Footer: React.FC<FooterProps> = ({
  justify = 'end',
  className,
  children,
}) => {
  return (
    <div
      className={classNames(
        'flex items-center bg-white px-10 py-3 shadow-top-dark-teal',
        { 'justify-start': justify === 'start' },
        { 'justify-end': justify === 'end' },
        { 'justify-center': justify === 'center' },
        className
      )}
    >
      {children}
    </div>
  );
};
